import React from 'react';
import { formatPercent } from 'utils';
import { TooltipBase } from './';
import { benchmarkFilter, formatName } from '../Utils/benchmarks';

interface PayloadItem {
  dataKey: string;
  color: string;
}

interface DataItem {
  date?: string;
  [key: string]: any;
}

const mapItems = (items: DataItem, payload: PayloadItem[]) => {
  return Object.keys(items).map(key => {
    if (key === 'date') return null;
    const value = items[key];
    const baseData = payload.find(item => item.dataKey === key);

    return (
      <div style={{ margin: '1em 0', display: 'flex' }} key={key}>
        <div
          style={{
            backgroundColor: baseData?.color || 'transparent',
            width: '16px',
            minWidth: '16px',
            height: '16px',
            minHeight: '16px',
            marginRight: '0.2rem',
            borderRadius: '50%',
            marginTop: '2px'
          }}
        />
        <span>
          {formatName(key)}: {formatPercent(value, true)}
        </span>
      </div>
    );
  });
};

const TooltipPastPerformance = ({ payload, benchmarks, activeDot }: any) => {
  const data = payload && payload[0] && payload[0].payload;
  if (!data) return null;
  const date = data.date;
  const activeBenchmarks: DataItem = {};
  const portfolios: DataItem = {};

  Object.entries(data).forEach(([key, value]) => {
    if (key === 'date') return;
    if (benchmarkFilter(benchmarks, key)) {
      activeBenchmarks[key] = value;
    } else {
      portfolios[key] = value;
    }
  });

  return (
    <TooltipBase style={{ padding: '0.2rem 1rem' }}>
      <p>{date}</p>
      {Object.keys(portfolios).length > 0 ? (
        <>
          <div style={{ fontWeight: 600 }}>Portfolio</div>
          {mapItems(portfolios, payload)}
        </>
      ) : (
        <></>
      )}
      {Object.keys(activeBenchmarks).length > 0 ? (
        <>
          <div style={{ fontWeight: 600 }}>Benchmarks</div>
          {mapItems(activeBenchmarks, payload)}
        </>
      ) : (
        <></>
      )}
      {activeDot && (
        <div style={{ display: 'flex', gap: '4px', paddingBottom: '1em' }}>
          <div style={{ fontWeight: 700 }}>Portfolio History:</div>
          <div>{activeDot['date']}</div>
        </div>
      )}
    </TooltipBase>
  );
};

export default TooltipPastPerformance;
